import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SearchIconIcon, CloseWhiteIcon } from 'components/ui-kit/Icons/svg/index'
import { setSearchGame } from 'redux-thunk/redux/slices/lobby.slice'
import { CASINO_TABS } from 'constants/index'
import { useDebounce } from 'react-use'

const SearchBar = (props) => {
  const dispatch = useDispatch()
  const [searchVal, setSearchVal] = useState('')
  const { searchGame, gameCategory, tab } = useSelector(
    (state) => state?.lobby
  )

  const handleSearchGame = (e) => {
    setSearchVal(e?.target?.value)
  }

  useDebounce(
    () => {
      dispatch(setSearchGame(searchVal))
    },
    1000,
    [searchVal]
  )

  const searchCancelHandler = () => {
    setSearchVal('')
  }

  useEffect(() => {
    setSearchVal(searchGame)
  }, [searchGame])

  return (
    <section className='casino-search'>
      <div className='casino-search-content home-casino-search'>
        <input
          type='text'
          className='form-control shadow-none'
          id='casinoSearch'
          placeholder={
            tab === CASINO_TABS.LOBBY || tab === CASINO_TABS.ORIGINALS
              ? 'Search your game'
              : `Search ${gameCategory}`
          }
          value={searchVal}
          onChange={(e) => handleSearchGame(e)}
        />
        <SearchIconIcon className='search-icon' />
        {searchGame?.length > 0 && (
          <button
            type='button'
            className='btn-close shadow-none'
            onClick={() => searchCancelHandler()}
          >
            <CloseWhiteIcon />
          </button>
        )}
      </div>
    </section>
  )
}

export default React.memo(SearchBar)
